import * as bookmarkApi from "../api/bookmark";
import * as breakpoints from "../breakpoints";
import * as colors from "../constants/colors";
import * as languages from "../constants/languages";
import { css, StyleSheet } from "aphrodite";
import { english, spanish } from "../constants/strings";
import { handleUnknownError } from "../lib/errorHandler";
import { format } from "date-fns";
import { me } from "../api/account";
import { browserHistory } from "react-router";
import { NotificationManager } from "react-notifications";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { rootUrl, lrsUrl, lrsAuth } from "../config.js";
import * as util from "../lib/util";
import querystring from "querystring";
import typeColors from "../constants/typeColors";
import * as courseTypes from "../constants/courseTypes";
import * as courseFormats from "../constants/courseFormats";

const styles = StyleSheet.create({
	accessibilityLink: {
		paddingTop: 12,
		display: "block",
	},
	bookmarkedContainer: {
		alignItems: "center",
		justifyContent: "flex-end",
		display: "flex",
		marginBottom: 8,
		zIndex: 2,
	},
	bookmarkButton: {
		backgroundColor: "transparent",
		border: "none",
		display: "flex",
		alignItems: "center",
		height: 22,
		[breakpoints.mobileOnly]: {
			height: 40,
		},
	},
	courseTypeText: {
		fontSize: 11,
		height: 14,
		flexGrow: 1,
		flexShrink: 0,
		flexBasis: "auto",
		fontFamily: "freight-sans-pro",
		fontWeight: "bold",
		color: colors.black,
	},
	courseTypeBackground: {
		paddingLeft: 4,
		paddingRight: 4,
	},
	bookmarkedIcon: {
		[breakpoints.mobileOnly]: {
			height: 40,
			width: 40,
		},
		height: 19,
		width: 19,
		marginLeft: 12,
	},
	bookmarkedText: {
		fontSize: 12,
		height: 14,
		fontFamily: "priori-sans",
		fontWeight: "bold",
		color: colors.darkTeal,
	},
	bookmarkedPlaceholder: {
		[breakpoints.tabletAndUp]: {
			height: 27, // bookmark container height + margin
			width: 27, // bookmark container height + margin
		},
	},
	button: {
		border: `2px solid ${colors.lightTeal2}`,
		borderRadius: 20,
		backgroundColor: colors.white,
		paddingLeft: 18,
		paddingRight: 18,
		paddingTop: 2,
		marginLeft: 8,
		fontSize: 12,
		fontFamily:
			"TrebuchetMS, Trebuchet MS, Lucida Grande, Lucida Sans Unicode, Lucida Sans, Tahoma,sans-serif",
		lineHeight: 1.75,
		color: colors.black2,
		fontWeight: "bold",
		zIndex: 2,
	},
	categoryText: {
		fontSize: 12,
		lineHeight: 1.25,
		minHeight: 15,
		color: colors.darkTeal,
		fontWeight: "normal",
		fontFamily:
			"TrebuchetMS, Trebuchet MS, Lucida Grande, Lucida Sans Unicode, Lucida Sans, Tahoma,sans-serif",
		[breakpoints.mobileOnly]: {
			fontSize: 14,
			lineHeight: 1.07,
		},
		[breakpoints.desktopOnly]: {
			":hover": {
				cursor: "pointer",
			},
		},
	},
	completionDate: {
		fontSize: 15,
		fontFamily: "priori-sans",
		color: colors.darkTeal,
		textAlign: "right",
		marginTop: 8,
		paddingRight: 18,
	},
	container: {
		paddingTop: 16,
		paddingRight: 16,
		paddingBottom: 12,
		paddingLeft: 16,
		[breakpoints.desktopOnly]: {
			":hover": {
				cursor: "pointer",
			},
		},
	},
	courseTitle: {
		[breakpoints.tabletAndUp]: {
			height: 45,
		},
		fontSize: 18,
		color: colors.darkTeal,
		lineHeight: 1,
		fontWeight: "normal",
		fontFamily: "priori-sans, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif",
		display: "block",
		textDecoration: "underline",
		[breakpoints.mobileOnly]: {
			fontSize: 18,
			lineHeight: 0.83,
		},
	},
	infoContainer: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "flex-start",
		marginTop: 8,
	},
	outerContainer: {
		marginBottom: 20,
	},
});

export default class CourseTile extends Component {
	static propTypes = {
		course: PropTypes.shape({
			name: PropTypes.string.isRequired,
			primaryCategoryName: PropTypes.string.isRequired,
			primaryCategoryID: PropTypes.string.isRequired,
			id: PropTypes.string.isRequired,
			image: PropTypes.object,
			classID: PropTypes.string.isRequired,
			bookmarked: PropTypes.bool,
			complete: PropTypes.bool,
			completionDate: PropTypes.string,
			isCertificate: PropTypes.bool,
			inProgress: PropTypes.bool,
			certificate: PropTypes.string,
			certificateCompletionDate: PropTypes.string,
			captivate: PropTypes.object,
			type: PropTypes.string.isRequired,
		}),
		color: PropTypes.string,
		showCertificate: PropTypes.func,
		updateBookmark: PropTypes.func,
		// categoryClicked: PropTypes.func,
		language: PropTypes.string.isRequired,
	};

	constructor(props) {
		super(props);

		this.strings = props.language === languages.es ? spanish : english;

		this.state = {
			course: props.course,
		};
	}

	componentWillReceiveProps(nextProps) {
		if (this.state.course.bookmarked !== nextProps.course.bookmarked) {
			this.setState({
				course: nextProps.course,
			});
		}
	}

	_categoryClicked = () => {
		// if (this.props.categoryClicked) {
		// 	this.props.categoryClicked(this.props.course.primaryCategoryID);
		// }
		this._start();
	};

	_certificate = e => {
		e.stopPropagation();
		this.props.showCertificate(this.props.course, this.props.course.certificate);
	};

	_continue = e => {
		e.stopPropagation();
		const { course } = this.props;
		me()
			.then(data => {
				const params = {
					email: data.email,
					auth: lrsAuth,
					endpoint: lrsUrl,
					actor: JSON.stringify({
						objectType: "Agent",
						mbox: `mailto:${data.email}`,
					}),
					activity_id: `http://${util.slugify(course.name.toLowerCase())}`,
				};

				if (this.state.course.format === courseFormats.captivate) {
					params.language = this.props.language ? this.props.language : "";
					params.continue = true;
				}
				const qs = querystring.stringify(params);

				const url = `${course.captivateURL}?${qs}`;
				window.location.assign(url);
			})
			.catch(err => {
				if (err.response && err.response.status === 401) {
					// NOTE: This is a stop-gap solution. Need to build real refresh interceptor
					util.deleteCookies();
					window.location.assign("/login");
				}
			});
	};

	_start = () => {
		browserHistory.push({
			pathname: `/class/${this.props.course.id}`,
			query: { language: this.props.language },
		});
	};

	_toggleBookmarked = e => {
		e.stopPropagation();
		const classID = this.props.course.id;
		const toggle = this.state.course.bookmarked
			? bookmarkApi.removeBookmark
			: bookmarkApi.bookmarkClass;
		toggle(classID)
			.then(response => {
				console.log(response);
				if (this.props.updateBookmark) {
					this.props.updateBookmark({
						...this.state.course,
						bookmarked: !this.state.course.bookmarked,
					});
				}
			})
			.catch(err => {
				handleUnknownError(err);
				NotificationManager.error(this.strings.errors.failedToBookmark);
			});
	};

	_renderButton = () => {
		if (this.props.course.isCertificate) {
			return (
				<div>
					<div>
						<button className={css(styles.button)} onClick={this._certificate}>
							{this.strings.CERTIFICATE}
						</button>
					</div>
					<div className={css(styles.completionDate)}>
						{format(this.props.course.completionDate, "M/D/YYYY")}
					</div>
				</div>
			);
		} else if (this.props.course.inProgress) {
			return (
				<button
					className={css(styles.button)}
					onClick={
						this.props.course.type === courseTypes.interactive ||
							this.props.course.type === courseTypes.video
							? this._continue
							: this._start
					}
				>
					{this.strings.CONTINUE}
				</button>
			);
		} else {
			return null;
			// (
			// 	<button className={css(styles.button)} onClick={this._start}>
			// 		{strings.START}
			// 	</button>
			// );
		}
	};

	_renderBookmarkRow = () => {
		const bgTypeStyle = StyleSheet.create({
			bg: {
				backgroundColor: typeColors[this.props.course.type],
				width: "14px",
				height: "13px",
				display: "inline-block",
				verticalAlign: "text-bottom",
			},
		});

		if (this.state.course.bookmarked) {
			return (
				<div className={css(styles.bookmarkedContainer)}>
					<div className={css(styles.courseTypeText)}>
						<span className={css(bgTypeStyle.bg)} />
						<span className={css([styles.courseTypeBackground])}>
							{this.strings.type[this.props.course.type].toUpperCase()}
						</span>
					</div>
					<button onClick={this._toggleBookmarked} className={css(styles.bookmarkButton)}>
						<div className={css(styles.bookmarkedText)}>
							{this.strings.REMOVE_BOOKMARK}
						</div>
						<img
							alt="bookmarked icon"
							className={css(styles.bookmarkedIcon)}
							src={`${rootUrl}/images/bookmark.png`}
							srcSet={`${rootUrl}/images/bookmark@2x.png 2x, ${rootUrl}/images/bookmark@3x.png 3x`}
						/>
					</button>
				</div>
			);
		} else {
			return (
				<div className={css(styles.bookmarkedContainer)}>
					<div className={css(styles.courseTypeText)}>
						<span className={css(bgTypeStyle.bg)} />
						<span className={css([styles.courseTypeBackground])}>
							{this.strings.type[this.props.course.type].toUpperCase()}
						</span>
					</div>
					<button onClick={this._toggleBookmarked} className={css(styles.bookmarkButton)}>
						<div className={css(styles.bookmarkedText)}>{this.strings.BOOKMARK}</div>
					</button>
				</div>
			);
		}
	};

	render() {
		const bgStyle = StyleSheet.create({
			bg: { backgroundColor: this.props.color ? this.props.color : colors.babyBlue },
		});

		const tileCss = css([styles.container, bgStyle.bg]);

		return (
			<div className={css(styles.outerContainer)}>
				<div className={tileCss}>
					<a
						onClick={
							this.props.course.inProgress &&
								(this.props.course.type === courseTypes.interactive ||
									this.props.course.type === courseTypes.video)
								? this._continue
								: this._start
						}
					>
						{this._renderBookmarkRow()}
						<img
							src={this.props.course.image.url1x}
							srcSet={
								this.props.course && this.props.course.image
									? `${this.props.course.image.url2x} 2x, ${this.props.course.image.url3x
									} 3x`
									: ""
							}
							width="100%"
							alt="Class"
						/>
						<div className={css(styles.infoContainer)}>
							<div>
								<div className={css(styles.categoryText)}>
									{this.props.course.primaryCategoryName}
								</div>
								<div className={css(styles.courseTitle)}>
									{this.props.course.name}
								</div>
							</div>
							<div>{this._renderButton()}</div>
						</div>
					</a>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/CourseTile.js